import { FileFieldCellDto } from '@/components/table/_fieldDefinitions/file/FileFieldCellDto.ts';

export enum LinkOrFileType {
  FILE = 'FILE',
  LINK = 'LINK',
}

export interface LinkOrFileCellDto {
  type: LinkOrFileType;
  file?: FileFieldCellDto | null;
  linkUrl?: string | null;
}
